import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {OphPageHeaderComponent} from '../../shared/design/oph-page-header/oph-page-header.component';
import {LensDialogData, LenseDialogComponent} from '../lense-dialog/lense-dialog.component';
import {LENS_DIALOG_SETTINGS} from '../utils/lenses.constants';
import {Lens} from '../shared/model/lens';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'lenses-header',
  standalone: true,
  imports: [OphPageHeaderComponent],
  templateUrl: './lenses-header.component.html',
  styleUrl: './lenses-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LensesHeaderComponent {
  private readonly mobileService = inject(MobileService);
  private dialog = inject(MatDialog);
  allLenses = input.required<Lens[]>();
  searchValueChange = output<string>();

  public addLens(): void {
    this.dialog.open(LenseDialogComponent, {
      data: {lens: null, lenses: this.allLenses()} as LensDialogData,
      ...LENS_DIALOG_SETTINGS,
      autoFocus: this.mobileService.isMobilePlatform() ? false : undefined,
    });
  }

  public onSearchChange(searchValue: string): void {
    this.searchValueChange.emit(searchValue);
  }
}
